import i18n from '@/i18n'
import { InfraLocaleUtils } from 'tws-vue-components'

export const getSelectedLocale = () => {
  return InfraLocaleUtils.getSelectedLocale()
}

export const isLocaleEnglish = () => {
  return getSelectedLocale() === InfraLocaleUtils.LOCALES.EN
}

export const getIframeLocalisedURL = (url) => {
  return isLocaleEnglish() ? url + '&target=SUSA_ENU' : url + '&target=SUSA'
}

export const getUserErrorMessage = (exception, failsafe) => {
  if (exception.message === 'Delegated administrator cannot use password login method!') {
    return i18n.t('user-creation.delegated-error')
  }
  return failsafe
}
